import type { QueryFunctionContext } from '@tanstack/react-query';
import { queryOptions } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { OptionsDTO } from './types';
import type { AdsLibraryApiPathParams } from './parseAdsLibraryApiPath';
import { parseAdsLibraryApiPath } from './parseAdsLibraryApiPath';

const getAdBranches = async ({
  signal,
  queryKey,
}: QueryFunctionContext<[string, string]>): Promise<OptionsDTO[]> => {
  const res = await apiClient.get<{ data: OptionsDTO[] }>(queryKey[1], {
    signal,
  });
  return res.data.data;
};

export const getAdBranchesOptions = (params: AdsLibraryApiPathParams = {}) =>
  queryOptions({
    staleTime: 60 * 60 * 1000,
    queryFn: getAdBranches,
    queryKey: ['ad-branches', parseAdsLibraryApiPath('ad_branches', params)] as const,
  });
